import { render, staticRenderFns } from "./ShowEventDotBase.vue?vue&type=template&id=30d4872e&scoped=true&"
import script from "./ShowEventDotBase.vue?vue&type=script&lang=ts&"
export * from "./ShowEventDotBase.vue?vue&type=script&lang=ts&"
import style0 from "./ShowEventDotBase.vue?vue&type=style&index=0&id=30d4872e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d4872e",
  null
  
)

export default component.exports